import { render, staticRenderFns } from "./ActivitiesForDisableComp.vue?vue&type=template&id=6f2b356f&scoped=true"
import script from "./ActivitiesForDisableComp.vue?vue&type=script&lang=js"
export * from "./ActivitiesForDisableComp.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesForDisableComp.vue?vue&type=style&index=0&id=6f2b356f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b356f",
  null
  
)

/* custom blocks */
import block0 from "./ActivitiesForDisableComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports